<div>
  <div class="vehicle-wrapper">
    <div class="top-header">
      <h3>Select Period</h3>
      <p>Results between the selected dates will be displayed</p>
    </div>

    <form [formGroup]="genarateReportFrom" (ngSubmit)="submitReport()">
      <!-- <div class="card-top card-head">
        <h4>Select Period</h4>
        <p>Results between the selected dates will be displayed</p>
      </div> -->
      <div class="date-form">
        <div class="form-group">
          <label for="fromDate">Select from Date <small>*</small></label>
          <!-- <input type="date" formControlName="fromDate" required > -->
           <p-datepicker formControlName="fromDate" 
                            dateFormat="dd/mm/yy"
                            [showIcon]="true"
                            inputId="fromDate"
                            [showOnFocus]="true" 
                            [showButtonBar]="true" 
                            [maxDate]="today"
                            [readonlyInput]="true"
                         appendTo="body"
                         required
                         [baseZIndex]="1200"/>
          <div class="error" *ngIf="genarateReportFrom.get('fromDate')?.invalid && genarateReportFrom.get('fromDate')?.touched">
            <small *ngIf="genarateReportFrom.get('fromDate')?.errors?.['required']">From date is required</small>
          </div>
        </div>
        <div class="form-group">
          <label for="toDate">Select to Date <small>*</small></label>
          <!-- <input type="date" formControlName="toDate" required> -->
           <p-datepicker formControlName="toDate" 
                            dateFormat="dd/mm/yy"
                            [showIcon]="true"
                            inputId="toDate"
                            [showOnFocus]="true" 
                            [showButtonBar]="true" 
                            [maxDate]="today"
                            [readonlyInput]="true"
                         appendTo="body"
                         required
                         [baseZIndex]="1200"/>
          <div class="error" *ngIf="genarateReportFrom.get('toDate')?.invalid && genarateReportFrom.get('toDate')?.touched">
            <small *ngIf="genarateReportFrom.get('toDate')?.errors?.['required']">To date is required</small>
          </div>
        </div>
      </div>
      <div class="ctr-btn">
        <button type="submit"
        class="btn-generate btn-action"
        
        >
          <fa-icon [icon]="['fas', 'square-poll-vertical']" class="fa-solid"></fa-icon>
          GENERATE
        </button>
      </div>
    </form>
  </div>
</div>

<div class="show-table-div" *ngIf="noRecords">
  <div class="error-msg">
      <p>
        <fa-icon [icon]="['fas', 'circle-exclamation']" class="fa-thin"></fa-icon>
        No records found in the given date range
      </p>
    </div>
</div>
<div class="show-table-div" *ngIf="showTable">
  <div class="top-header">
    <h3>Vehicle Activity</h3>
    <p>Vehicle details as on {{genarateReportFrom.value.fromDate | reportingDate:'date'}} to
      {{genarateReportFrom.value.toDate | reportingDate:'date'}}</p>
  </div>
    <div class="table-container">
    <!-- <div class="card-top card-head">
      <h4>Vehicle Activity</h4>
      <p>Vehicle details as on {{genarateReportFrom.value.fromDate | reportingDate:'date'}} to {{genarateReportFrom.value.toDate | reportingDate:'date'}}</p>
    </div> -->
        <app-shared-table-toolbar>
            <div toolbarSearch class="search-bar">
          <app-generic-search
                  [apiUrl]="'generate-report/search_suggestion'"
                  [resultsApiUrl]="'generate-report/'"
                  [method]="'POST'"
                  [searchParamName]="'search_text'"
                  [extraBody]="{ camera_esn: camera_esn, 'from_date': rawData.from_date, 'to_date': rawData.to_date }"
                  [pageSize]="10"
                  [minChars]="2"
                  (resultsFetched)="onResults($event)">
          </app-generic-search>
      </div>
            <div toolbarFilters class="filters table-filters" [formGroup]="genarateReportFrom">
        <div class="filter">
          <label>Status</label>
          <select formControlName="dashboardFilter" (change)="onStatusChange()">
            <option value="">All</option>
            <option value="Authorized">Authorized</option>
            <option value="Unauthorized">Unauthorized</option>
          </select>
        </div>
        <div class="filter">
          <label>Direction</label>
          <select formControlName="directionFilter" (change)="onDirectionChange()">
            <option value="">All</option>
            <option value="Entry">Entry</option>
            <option value="Exit">Exit</option>
          </select>
        </div>
      </div>
            <button toolbarTrailing type="button" (click)="exportToExcel()" class="export-button">
        <fa-icon [icon]="['fas', 'file-excel']" class="fa-thin" style="color: white;font-size: 15px;"></fa-icon>
        EXPORT EXCEL
      </button>
        </app-shared-table-toolbar>
    <div class="responsive-table-wrapper">
      <table>
        <thead class="table-name">
          <tr>
            <th>S.No</th>
              <th>Authorized</th>
            <th class="sortable-header" (click)="sortData('vehicle_number')">
                  Vehicle Number
              <span class="sort-indicator">
                <fa-icon *ngIf="sortColumn === 'vehicle_number' && sortDirection === 'desc'"
                         [icon]="['fas', 'arrow-down']"></fa-icon>
                <fa-icon *ngIf="sortColumn === 'vehicle_number' && sortDirection === 'asc'"
                         [icon]="['fas', 'arrow-up']"></fa-icon>
              </span>
              </th>
            <th class="sortable-header" (click)="sortData('created_at')">
                Date &amp; Time
              <span class="sort-indicator">
                <fa-icon *ngIf="sortColumn === 'created_at' && sortDirection === 'desc'"
                         [icon]="['fas', 'arrow-down']"></fa-icon>
                <fa-icon *ngIf="sortColumn === 'created_at' && sortDirection === 'asc'"
                         [icon]="['fas', 'arrow-up']"></fa-icon>
              </span>
              </th>
            <th class="sortable-header" (click)="sortData('direction')">
                  Direction
              <span class="sort-indicator">
                <fa-icon *ngIf="sortColumn === 'direction' && sortDirection === 'desc'"
                         [icon]="['fas', 'arrow-down']"></fa-icon>
                <fa-icon *ngIf="sortColumn === 'direction' && sortDirection === 'asc'"
                         [icon]="['fas', 'arrow-up']"></fa-icon>
              </span>
              </th>
            <th class="sortable-header" (click)="sortData('camera_esn')">
                  Camera
              <span class="sort-indicator">
                <fa-icon *ngIf="sortColumn === 'camera_esn' && sortDirection === 'desc'"
                         [icon]="['fas', 'arrow-down']"></fa-icon>
                <fa-icon *ngIf="sortColumn === 'camera_esn' && sortDirection === 'asc'"
                         [icon]="['fas', 'arrow-up']"></fa-icon>
              </span>
              </th>
              <th *ngFor="let column of vteColumns">{{ column.label }}</th>
            <th>Vehicle Image</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let record of reportData; let i = index">
            <td>{{ i + 1 + (currentPage - 1) * recordsPerPage }}</td> <!-- 10 -> pagesize -->
            <td>
              <span [ngClass]="record.is_match ? 'green-circle' : 'red-circle'" ></span>
            </td>
              <td [appVehicleNumberCopy]="record.vehicle_number">{{ record.vehicle_number }}</td>
              <td>{{ record.created_at | reportingDate }}</td>
            <td>{{ record.direction }}</td>
            <td>{{ displayCameraEsn(record) }}</td>
              <td *ngFor="let column of vteColumns">
                  <app-dynamic-column-host [column]="column" [row]="record"></app-dynamic-column-host>
              </td>
            <td>
              <button (click)="viewImage(record.vehicle_image_url, record.direction )">
                <fa-icon [icon]="['fas', 'eye']" class="fa-light"></fa-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    
      <div class="footer">
        <div class="total-records">Total Records: {{ totalRecords }}</div>
          <app-vte-pagination
                  [currentPage]="currentPage"
                  [pageSize]="recordsPerPage"
                  [totalRecords]="totalRecords"
                  [showJumpToPage]="true"
                  (pageChange)="onPageChange($event)"
                  (pageSizeChange)="onPageSizeChange($event)">
          </app-vte-pagination>
      </div>
    </div>
  </div>
</div>

<!-- Add this modal HTML below your table -->
<app-image-viewer
  [images]="selectedImages"
  [show]="showModal"
  [closeModal]="closeModal"
></app-image-viewer>

<div *ngIf="showUnappliedFiltersDialog" class="confirmation-modal" role="dialog" aria-modal="true"
     aria-labelledby="unapplied-filters-title">
    <div class="modal-content">
        <div class="modal-header">
            <i class="bi bi-exclamation-triangle warning-icon" aria-hidden="true"></i>
            <h3 id="unapplied-filters-title">Unapplied Filter Changes</h3>
        </div>
        <div class="modal-body">
            <p>
                You have modified the report filters but have not applied them yet.
            </p>
            <p>
                Please click <strong>Generate Report</strong> to refresh the results before navigating between pages.
            </p>
        </div>
        <div class="modal-footer">
            <button type="button" class="confirm-btn modal-green" (click)="applyUnappliedFilters()">
                Apply Filters
            </button>
            <button type="button" class="cancel-btn cancel-btn-green" (click)="cancelUnappliedFiltersDialog()">
                Cancel
            </button>
        </div>
    </div>
</div>
